import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class MiniConfigurationSummaryStyle {
	/**
	 * Returns style.
	 *
	 * @param options Options.
	 * @param options.theme Theme.
	 * @returns Css.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { spacing } = options.theme;

		return css`
			:host {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				pointer-events: none;
				user-select: none;
			}
			.container {
				display: flex;
				align-items: stretch;
			}
			#whatsIncluded {
				align-self: center;
			}
			kompis-mini-price {
				justify-content: space-evenly;
			}
			.divider {
				display: flex;
				width: ${spacing.space100 / 16}rem;
				flex-shrink: 0;
			}
			skapa-button,
			skapa-icon-button {
				align-self: flex-start;
				pointer-events: auto;
			}
		`;
	}
}
